import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import appPromoImage from '../assets/paszport-dolnego-slaska-aplikacja.png'
import { useT } from '../i18n/t'
import { fadeUp } from '../lib/motion'

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=pl.paszportdolnegoslaska.app'

export function LandingAppSection() {
  const { t } = useT()

  return (
    <section
      aria-labelledby="landing-app-heading"
      className="border-y border-ink/10 bg-paper"
    >
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
        className="container-x py-14 md:py-20"
      >
        <div className="content grid grid-cols-1 items-center gap-10 md:grid-cols-[0.95fr_1.05fr] md:gap-14">
          <motion.div variants={fadeUp} className="flex justify-center md:justify-start">
            <img
              src={appPromoImage}
              alt={t('landing.app.imageAlt')}
              draggable={false}
              loading="lazy"
              decoding="async"
              className="h-auto w-full max-w-[280px] select-none object-contain sm:max-w-[320px] md:max-w-[360px]"
            />
          </motion.div>

          <div>
            <motion.h2
              id="landing-app-heading"
              variants={fadeUp}
              className="display max-w-[22ch] text-[26px] font-bold leading-[1.12] text-ink md:max-w-none md:text-[40px]"
            >
              {t('landing.app.title')}
            </motion.h2>

            <motion.p
              variants={fadeUp}
              className="mt-4 max-w-[52ch] text-[15px] font-medium leading-relaxed text-ink/65 md:text-base"
            >
              {t('landing.app.subtitle')}
            </motion.p>

            <motion.div variants={fadeUp} className="mt-8">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group join-cta-primary inline-flex items-center justify-center gap-2 rounded-lg bg-brand px-8 py-4 text-lg font-extrabold tracking-tight text-brand-ink shadow-[0_14px_40px_rgba(241,201,1,0.35)] transition hover:brightness-[1.03] active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/70 focus-visible:ring-offset-2 focus-visible:ring-offset-paper"
              >
                <span>{t('landing.app.cta')}</span>
                <ArrowRight
                  className="h-[1.1em] w-[1.1em] shrink-0 transition group-hover:translate-x-0.5"
                  aria-hidden
                />
              </a>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>
  )
}
